<style>
.login-container {
  width: 100%;
  max-width: 420px;
  animation: fadeIn 0.5s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.login-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  padding: 40px 35px;
  text-align: center;
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.login-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #07c160, #1aad19, #07c160);
}

.logo {
  margin-bottom: 35px;
}

.logo-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #07c160 0%, #1aad19 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
  color: white;
  font-size: 28px;
  box-shadow: 0 4px 12px rgba(7, 193, 96, 0.3);
}

.logo h2 {
  color: #333;
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 24px;
}

.logo p {
  color: #888;
  font-size: 14px;
}

.login-methods {
  margin-top: 30px;
}

.login-method-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 52px;
  border: 1px solid #e4e7ed;
  border-radius: 26px;
  margin-bottom: 18px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: #606266;
  background: white;
  position: relative;
  overflow: hidden;
}

.login-method-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(7, 193, 96, 0.1) 0%, rgba(26, 173, 25, 0.1) 100%);
  opacity: 0;
  transition: opacity 0.3s;
}

.login-method-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
  border-color: #07c160;
  color: #07c160;
}

.login-method-item:hover::before {
  opacity: 1;
}

.wechat-login {
  background: linear-gradient(135deg, #07c160 0%, #1aad19 100%);
  border: none;
  color: white;
  box-shadow: 0 4px 12px rgba(7, 193, 96, 0.3);
}

.wechat-login:hover {
  background: linear-gradient(135deg, #06ad56 0%, #179a16 100%);
  box-shadow: 0 6px 20px rgba(7, 193, 96, 0.4);
  color: white;
  border: none;
}

.method-icon {
  margin-right: 12px;
  font-size: 20px;
  position: relative;
  z-index: 1;
}

.method-text {
  font-size: 16px;
  font-weight: 500;
  position: relative;
  z-index: 1;
}

/* 二维码弹窗样式 */
.qr-dialog {
  border-radius: 16px;
  overflow: hidden;
}

.qr-dialog .el-dialog__header {
  background: linear-gradient(135deg, #07c160 0%, #1aad19 100%);
  padding: 2rem;
}

.qr-dialog .el-dialog__title {
  color: white;
  font-weight: 600;
  font-size: 18px;
}

.qr-dialog .el-dialog__headerbtn .el-dialog__close {
  color: white;
  font-size: 1.6rem
}

.qr-dialog .el-dialog__body {
  padding: 30px;
}

.qr-code-container {
  text-align: center;
}

.qr-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.qr-header-icon {
  width: 42px;
  height: 42px;
  background: linear-gradient(135deg, #07c160 0%, #1aad19 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin-right: 12px;
  box-shadow: 0 3px 8px rgba(7, 193, 96, 0.3);
}
.qr-header-icon img{
  width: 1.8rem;
}

.qr-header-text h3 {
  color: #333;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 4px;
}

.qr-header-text p {
  color: #888;
  font-size: 13px;
}

.qr-code-wrapper {
  position: relative;
  margin: 0 auto 25px;
  width: 220px;
  height: 220px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid #f0f0f0;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-code {
  width: 200px;
  height: 200px;
  transition: opacity 0.3s;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}


.qr-code-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  animation: fadeIn 0.3s ease-out;
}

.qr-code-overlay i {
  font-size: 48px;
  color: #07c160;
  margin-bottom: 15px;
}

.qr-code-overlay p {
  color: #333;
  font-size: 16px;
  margin-bottom: 10px;
  font-weight: 500;
}

.qr-code-overlay .overlay-subtext {
  color: #666;
  font-size: 14px;
  margin-bottom: 20px;
}

.qr-tips {
  background: #f8f9fa;
  border-radius: 10px;
  padding: 5px 18px;
  margin-bottom: 25px;
  text-align: left;
  border-left: 4px solid #07c160;
}

.qr-tips h4 {
  color: #333;
  font-size: 14px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.qr-tips h4 i {
  margin-right: 8px;
  color: #07c160;
}

.qr-tips ul {
  list-style: none;
  padding-left: 5px;
}

.qr-tips li {
  color: #666;
  font-size: 13px;
  line-height: 1.6;
  margin-bottom: 6px;
  position: relative;
  padding-left: 15px;
}

.qr-tips li::before {
  content: '•';
  color: #07c160;
  position: absolute;
  left: 0;
}

.qr-status {
  display: flex;
  align-items: center;
  justify-content: start;
  margin-bottom: 25px;
  padding: 12px;
  border-radius: 10px;
  background: #f8f9fa;
}

.status-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.status-waiting .status-icon {
  background: #e6f7ff;
  color: #1890ff;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

.status-scanning .status-icon {
  background: #f6ffed;
  color: #52c41a;
}

.status-expired .status-icon {
  background: #fff2f0;
  color: #ff4d4f;
}

.status-info {
  text-align: left;
}

.status-title {
  font-weight: 500;
  font-size: 15px;
  color: #333;
  margin-bottom: 2px;
}

.status-desc {
  font-size: 13px;
  color: #666;
}

.countdown {
  color: #07c160;
  font-weight: 600;
  margin: 0 3px;
}

.qr-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 25px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}

.qr-actions {
  display: flex;
  gap: 10px;
}

.refresh-btn {
  display: flex;
  align-items: center;
  justify-content: center;
}

.refresh-btn i {
  margin-right: 6px;
  transition: transform 0.3s;
}

.refresh-btn:hover i {
  transform: rotate(180deg);
}

.login-success {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease-out;
}

.success-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #07c160 0%, #1aad19 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 40px;
  margin-bottom: 25px;
  box-shadow: 0 8px 25px rgba(7, 193, 96, 0.3);
  animation: scaleIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes scaleIn {
  from { transform: scale(0); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.login-success h3 {
  font-size: 24px;
  color: #333;
  margin-bottom: 10px;
  font-weight: 600;
}

.login-success p {
  color: #666;
  font-size: 16px;
  margin-bottom: 30px;
}

.progress-bar {
  width: 200px;
  height: 4px;
  background: #f0f0f0;
  border-radius: 2px;
  overflow: hidden;
  margin-top: 20px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #07c160, #1aad19);
  border-radius: 2px;
  animation: progress 2s linear forwards;
}

@keyframes progress {
  from { width: 0; }
  to { width: 100%; }
}

.footer-tips {
  margin-top: 35px;
  color: #999;
  font-size: 12px;
  line-height: 1.6;
}

.footer-tips p {
  margin-bottom: 5px;
}

.footer-tips a {
  color: #07c160;
  text-decoration: none;
}

.footer-tips a:hover {
  text-decoration: underline;
}

/* 响应式调整 */
@media (max-width: 480px) {
  .login-card {
    padding: 30px 25px;
    border-radius: 12px;
  }

  .qr-dialog .el-dialog {
    width: 90% !important;
    max-width: 350px;
  }

  .qr-dialog .el-dialog__body {
    padding: 25px 20px;
  }

  .qr-code-wrapper {
    width: 200px;
    height: 200px;
  }

  .qr-code {
    width: 180px;
    height: 180px;
  }
}

.scanning-animation {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
}

.scan-line {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, transparent, #07c160, transparent);
  animation: scan 2s linear infinite;
}

@keyframes scan {
  0% { top: 0; }
  100% { top: 100%; }
}

</style>

<template>
  <!-- 二维码弹窗 -->
  <!-- 二维码弹窗 -->
  <el-dialog
      :visible.sync="qrCodeDialogVisible"
      :before-close="handleCloseDialog"
      custom-class="qr-dialog"
      center
      :destroyOnClose="true"
      width="420px">
    <div class="qr-code-container">
      <div class="qr-header">
        <div class="qr-header-icon">
          <img src="@/assets/login/wechat_white.png">
        </div>
        <div class="qr-header-text">
          <h3>微信扫码登录</h3>
          <p>安全快捷，一键登录</p>
        </div>
      </div>

      <div class="qr-code-wrapper">
        <!-- 二维码图片 -->
        <div class="qr-code">
          <div class="QRCode" :style="{'width':180, 'height':180}">
            <div id="wechatLoginCanvas" ref="wechatLoginCanvasRef" style="width: 100%;height: 100%;margin-top: 2px;"></div>
          </div>
          <!-- 扫码扫描动画 -->
          <div class="scanning-animation" v-if="scanStatus === 'scanning'">
            <div class="scan-line"></div>
          </div>
        </div>
        <!-- 二维码过期遮罩 -->
        <div class="qr-code-overlay" v-if="scanStatus === 'expired'" @click="refreshQRCode">
          <i class="el-icon-refresh"></i>
          <p>二维码已过期</p>
          <p class="overlay-subtext">请点击刷新二维码</p>
        </div>

        <!-- 扫码成功遮罩 -->
        <div class="qr-code-overlay" v-if="scanStatus === 'success'">
          <i class="el-icon-success"></i>
          <p>扫码成功</p>
          <p class="overlay-subtext">正在登录，请稍候...</p>
        </div>
      </div>

      <!-- 状态提示 -->
      <div class="qr-status" :class="'status-' + scanStatus">
        <div class="status-icon">
          <i :class="statusIcon"></i>
        </div>
        <div class="status-info">
          <div class="status-title">{{ statusTitle }}</div>
          <div class="status-desc" v-html="statusDesc"></div>
        </div>
      </div>

      <!-- 扫码步骤提示 -->
      <div class="qr-tips">
        <h4><i class="el-icon-info"></i> 扫码步骤</h4>
        <ul>
          <li>打开手机微信，点击右上角"+"号</li>
          <li>选择"扫一扫"功能，扫描上方二维码</li>
          <li>在手机上点击"确认登录"完成登录</li>
        </ul>
      </div>

    </div>
  </el-dialog>
</template>


<script>
import QRCode from "qrcode";
import {WechatOauthApi} from "@/api/server/wechatOauth";

export default {
  components: {},
  data() {
    return {
      qrCodeDialogVisible: false,
      scanStatus: 'waiting', // waiting, scanning, success, expired
      countdown: 120,
      timer: null,
      qrCodeUrl: 'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=weixin://dl/business/?ticket=模拟微信登录ticket&color=07c160',
      refreshing: false,
      showHelp: false,
      showSuccessPage: false,
      confirmLoading: false,
      userInfo: {
        nickname: '微信用户',
        avatar: ''
      },
      scanTimer: null,
      state: ''
    };
  },
  computed: {
    statusIcon() {
      const icons = {
        waiting: 'el-icon-time',
        scanning: 'el-icon-view',
        success: 'el-icon-success',
        expired: 'el-icon-error'
      };
      return icons[this.scanStatus];
    },
    statusTitle() {
      const titles = {
        waiting: '等待扫码',
        scanning: '扫码成功',
        success: '等待确认',
        expired: '二维码已过期'
      };
      return titles[this.scanStatus];
    },
    statusDesc() {
      if (this.scanStatus === 'waiting') {
        return `请使用微信扫描二维码，二维码将在 <span class="countdown">${this.countdown}</span> 秒后过期`;
      } else if (this.scanStatus === 'scanning') {
        return '已扫描，请在手机上确认登录';
      } else if (this.scanStatus === 'success') {
        return '请在手机上点击"确认登录"按钮';
      } else {
        return '二维码已过期，请点击刷新按钮获取新二维码';
      }
    },
    confirmButtonText() {
      return this.confirmLoading ? '登录中...' : '确认登录';
    }
  },
  methods: {
    show() {
      this.qrCodeDialogVisible = true;
      this.startCountdown();
      this.scanStatus = 'waiting';
      this.$nextTick(()=>{
        this.refreshQRCode();
      })
    },
    startCountdown() {
      this.countdown = 120;
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.scanStatus = 'expired';
        }
      }, 1000);
    },
    async checkScanStatus() {
      if(this.scanTimer){
        clearInterval(this.scanTimer);
      }
      this.scanTimer = setInterval(async () => {
        const params = {state: this.state}
        const {code,data} = await WechatOauthApi.check(params);
        if(code == 200){
          this.scanStatus = 'success';
          if(this.scanTimer){
            clearInterval(this.scanTimer);
          }
          setTimeout( () => {
            this.qrCodeDialogVisible = false;
            const result = {openid: data?.rawUserInfo?.openid, unionid: data?.rawUserInfo?.unionid, state: this.state};
            this.$emit('success',result);
          },1500)
        }
      },2000)
    },
    refreshQRCode() {
      this.refreshing = true;
      //获取二维码链接
      this.$refs.wechatLoginCanvasRef.innerHTML = '';
      WechatOauthApi.render().then(res => {
        const {code,data} = res;
        if(code == 200){
          const {state,url} = data;
          this.state = state;
          QRCode.toCanvas(url, {
            width: 150,
            height: 150,
            margin: 0,
            scale: 10, // 二维码的每个模块占用的像素数，默认为4
            errorCorrectionLevel: "L",
            color: { // 二维码的颜色配置
              dark: '#000000', // 深色模块的颜色
              light: '#ffffff' // 浅色模块的颜色（背景色）
            }
          },(error, canvas) => {
            if (error) {
              console.error(error);
              return;
            }
            // 在canvas的父元素中插入canvas元素
            this.$nextTick(() => {
              this.$refs.wechatLoginCanvasRef.appendChild(canvas);
            });
          })
          this.scanStatus = 'waiting';
          this.startCountdown();
          this.checkScanStatus();
        }
      }).finally(() => {
        this.refreshing = false;
      })
    },
    handleCloseDialog(done) {
      clearInterval(this.timer);
      done();

    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.scanTimer) {
      clearTimeout(this.scanTimer);
    }
  }
};
</script>